export default "__VITE_ASSET__9RWMcUt1__"